import React from 'react';
import { Core } from './core/Core';
import Erp from './erp/Erp';

const App = () => {
  return (
    <Core>
      <Erp></Erp>
    </Core>
  );
};

export default App;
